import { render } from "./HeroiconsSolidDocumentReport.vue?vue&type=template&id=78d0c61a"
const script = {}

import exportComponent from "/var/www/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidDocumentReport.vue"]])

export default __exports__